import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showTokenExpiredAlert, getConfig, authHeader, getCustId, isApiSuccess } from "utils";

// GET subscriber/getActivePlanList/{custId} -> dataList
export const activePlanList = createAsyncThunk('activePlan/list', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `subscriber/getActivePlanList/${getCustId()}`,
            headers: authHeader()
        })
        return res
    } catch (error) {
        return error.response
    }
})

// "Associated Vas" popup: GET subscriber/getActivePlanVasList/{planmapid} -> dataList
export const associatedVasList = createAsyncThunk('activePlan/vasList', async ({ planMapId, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `subscriber/getActivePlanVasList/${planMapId}`,
            headers: authHeader()
        })
        return res
    } catch (error) {
        return error.response
    }
})

const activePlan = createSlice({
    name: 'activePlan',
    initialState: {
        list: [],
        vasList: [],
        loading: false,
        vasLoading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(activePlanList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(activePlanList.fulfilled, (state, action) => {
            state.loading = false;
            if (isApiSuccess(action?.payload)) {
                state.list = action.payload.data.dataList || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else {
                state.list = []
            }
        });
        builder.addCase(activePlanList.rejected, (state) => {
            state.loading = false;
        });

        builder.addCase(associatedVasList.pending, (state) => {
            state.vasLoading = true;
            state.vasList = [];
        });
        builder.addCase(associatedVasList.fulfilled, (state, action) => {
            state.vasLoading = false;
            if (isApiSuccess(action?.payload)) {
                state.vasList = action.payload.data.dataList || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else {
                state.vasList = []
            }
        });
        builder.addCase(associatedVasList.rejected, (state) => {
            state.vasLoading = false;
        });
    }
})

export default activePlan.reducer;
